'use client'

import { usePathname } from 'next/navigation'
import { navigateUrl } from '@/utils/client-request'

export type ProfileNavKey = 'orders' | 'loyalty' | 'wishlist' | 'addresses' | 'settings' | 'logout'

export type ProfileNavItem = {
  key: ProfileNavKey
  name: string
  url: string
  basePath: string
  isActive: boolean
  isLogout?: boolean
}

const ITEMS: Array<{ key: ProfileNavKey; name: string; basePath: string; isLogout?: boolean }> = [
  { key: 'orders', name: 'Захиалгууд', basePath: '/order' },
  { key: 'loyalty', name: 'Лояалти оноо', basePath: '/points' },
  { key: 'wishlist', name: 'Хүслийн жагсаалт', basePath: '/wishlist' },
  { key: 'addresses', name: 'Миний хаягууд', basePath: '/address' },
  { key: 'settings', name: 'Тохиргоо', basePath: '/settings' },
  { key: 'logout', name: 'Гарах', basePath: '/logout', isLogout: true },
]

export const PROFILE_PATHS = ['/profile', '/order', '/address', '/settings', '/wishlist', '/points', '/login']

export function isProfileRoute(pathname: string | null | undefined): boolean {
  if (!pathname) return false
  return PROFILE_PATHS.some(p => pathname.includes(p))
}

export function useProfileNav(): { items: ProfileNavItem[]; accountItems: ProfileNavItem[]; logoutItem?: ProfileNavItem } {
  const pathname = usePathname()
  const normalized = pathname?.split('?')[0] || ''
  const items: ProfileNavItem[] = ITEMS.map(it => {
    const url = navigateUrl(it.basePath, pathname)
    return {
      ...it,
      url,
      isActive: normalized.startsWith(url),
    }
  })
  return {
    items,
    accountItems: items.filter(i => !i.isLogout),
    logoutItem: items.find(i => i.isLogout),
  }
}
